import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.to-fixed.js";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { BookingStatus, PaymentStatus } from "@/types/db/product-slot-state";
import BookingModule from "@/store/modules/booking";
import { DiscountTypes } from "@/interfaces/store/IBooking";
import { BookingStep } from "@/constants/booking";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import { initiateDiscount, refreshDiscount } from "@/utils/vue-helpers/discount";
import { pssUnpaidValue, restToPay, createGenericDiscountAccountings, isPSSPaid, removeGenericDiscountAccountings, removeAllPaymentCodePendingAccountings, removeAllDiscountCodePendingAccountings, createDiscountCodeAccounting, createPaymentCodeAccounting, excludedTaxByPss } from "@/utils/vue-helpers/new-accountings";
import calculatorSvg from "@/assets/images/svg/calculator-sign.svg";
import dayjs from "dayjs";
import { PromocodeCampaignType } from "@/types/db/accounting";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { cloneDeep } from "lodash";
import { LogService } from "@/services/logging";
import { Currencies } from "@/constants/currency";
import { roundToNearestMultipleOf5, sumArray } from "@/utils/helpers/common";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
export default defineComponent({
  name: "app",
  setup: function setup() {
    var calcIcon = calculatorSvg;
    var calcAlt = "calculator";
    var calcIconStyle = "width: 30px; height: 30px;";

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var predefinedDiscounts = {
      values: [],
      percentages: [10, 20, 50, 100]
    };
    var discountInfo = computed(function () {
      var _BookingModule$select, _BookingModule$select2, _BookingModule$select3;

      return {
        type: (_BookingModule$select = BookingModule.selectedBookingDiscountTrack) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.type,
        value: (_BookingModule$select2 = BookingModule.selectedBookingDiscountTrack) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.value,
        isOnAllOrder: (_BookingModule$select3 = BookingModule.selectedBookingDiscountTrack) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.isOnAllOrder,
        pssList: [],
        bookingId: BookingModule.selectedBookingUUID
      };
    });
    var currency = computed(function () {
      var _BookingModule$select4;

      return (_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.currency;
    });
    var isDiscountApplied = computed(function () {
      if (BookingModule.selectedBookingDiscountTrack && BookingModule.selectedBookingDiscountTrack.isApplied) {
        return true;
      }

      return false;
    });
    var discountResult = computed(function () {
      // Returns the amount of the discount:
      // 1- If the discount type is percentage X, then discountAmount = concerned prices Amount * X / 100
      // 2- If the discount type is a value X chf, the discountAmount = X * 100 (because it is in cents)
      var discount = 0;

      if (discountInfo.value.type === 1) {
        var sum = 0;

        if (BookingModule.selectedBooking) {
          var _BookingModule$select5, _BookingModule$select6;

          // Only prices concerned bu the discount will be considerd when calculating the sum of the order
          var discountPrices = (_BookingModule$select5 = BookingModule.selectedBookingDiscountTrack) === null || _BookingModule$select5 === void 0 ? void 0 : _BookingModule$select5.pricesIds;

          if (!discountPrices || discountPrices.length === 0) {
            // even though the type of this discount is to be applied on specific tickets yet we have no tickets concerned about it, lets return 0
            return 0;
          } // lets calculate the sum of the pss values of this booking (but remember! we already filtered prices that are not concerned by this discount)


          (_BookingModule$select6 = BookingModule.selectedBooking) === null || _BookingModule$select6 === void 0 ? void 0 : _BookingModule$select6.pssList.filter(function (pss) {
            return (discountPrices === null || discountPrices === void 0 ? void 0 : discountPrices.findIndex(function (priceId) {
              return priceId === pss.priceId;
            })) > -1 && !isPSSPaid(pss) && pss.paymentStatus !== PaymentStatus.Completed && pss.bookingStatus !== BookingStatus.Canceled && pss.bookingStatus !== BookingStatus.Abandoned;
          }).map(function (pss) {
            return getPSSValue(pss);
          }).forEach(function (pssValue) {
            return sum = sum + pssValue;
          });
          discount = discountInfo.value.value * sum / 100;
        }
      } else if (discountInfo.value.type === 2) {
        discount = discountInfo.value.value * 100; // converted to cents
      }

      if (currency.value === Currencies.CHF) {
        // Round discount value to a multiple of 5 for CHF transactions
        discount = roundToNearestMultipleOf5(discount);
      }

      return discount;
    });
    var bookingTotalAmount = computed(function () {
      var _BookingModule$select7;

      var sum = 0;
      (_BookingModule$select7 = BookingModule.selectedBooking) === null || _BookingModule$select7 === void 0 ? void 0 : _BookingModule$select7.pssList.map(function (pss) {
        return getPSSValue(pss);
      }).forEach(function (pssValue) {
        return sum = sum + pssValue;
      });
      return sum;
    });

    function updateDiscountType(typeValue) {
      var _BookingModule$select8;

      // Update type to whether value discount or percentage discount
      // Do nothing if it is the same discount type
      var currentDiscountType = (_BookingModule$select8 = BookingModule.selectedBookingDiscountTrack) === null || _BookingModule$select8 === void 0 ? void 0 : _BookingModule$select8.type;

      if (currentDiscountType === typeValue) {
        return;
      }

      BookingModule.updateDiscountType({
        BookingUUID: BookingModule.selectedBookingUUID,
        type: typeValue
      }); // Since we updated discount type lets erase the previous discount value to a default of 10

      BookingModule.updateDiscountValue({
        BookingUUID: BookingModule.selectedBookingUUID,
        value: 5
      });
    }

    function updateDiscountValue(val) {
      // Update the discount raw value (e.g: 20%, 50 CHF ... )
      BookingModule.updateDiscountValue({
        BookingUUID: BookingModule.selectedBookingUUID,
        value: val
      }); // discountInfo.value.value = val;
    }

    function UpdateDiscountApplicationCoverage() {
      ModalModule.setStatus(ModalStatus.DiscountSelectTickets);
    }

    function makeDiscountOnAllOrder() {
      var _BookingModule$select9, _BookingModule$select10;

      BookingModule.updateDiscountCoverage({
        BookingUUID: BookingModule.selectedBookingUUID,
        isOnAllOrder: true
      });
      BookingModule.updateDiscountPrices({
        BookingUUID: BookingModule.selectedBookingUUID,
        pricesIds: _toConsumableArray(new Set((_BookingModule$select9 = BookingModule.selectedBooking) === null || _BookingModule$select9 === void 0 ? void 0 : _BookingModule$select9.pssList.map(function (pss) {
          return pss.priceId;
        })))
      });
      discountInfo.value.pssList = ((_BookingModule$select10 = BookingModule.selectedBooking) === null || _BookingModule$select10 === void 0 ? void 0 : _BookingModule$select10.pssList) || [];
    }

    function showCalculator() {
      ModalModule.setStatus(ModalStatus.PaymentCalculator);
    }

    function applyDiscount2() {
      var _BookingModule$select11, _BookingModule$select12;

      LogService.info("User clicked to apply generic discount, uuid:".concat((_BookingModule$select11 = BookingModule.selectedBooking) === null || _BookingModule$select11 === void 0 ? void 0 : _BookingModule$select11.uuid)); // Apply the discount using the current info stored in discountInfo object
      // 1- calculate discount of each pss using a percentage
      // (this percentage is the same as user has entered if he chose percentage discount)
      // (if user chose value discount, then we should calculate the percentage ourselves)
      // In this point and to have correct values of pss.priceValue before applying the discount, keep
      // in mind that the pss can have a promocode applied in BookingModule.promocode. So consider it as
      // pss.priceValue -  promocodeDiscount
      // 2- if booking has accounting, remove it ... keep in mind that a booking that had discount and had accounting is now having fake pss.priceValue
      // 3- call createPosAccounting

      var bookingCopy1 = cloneDeep(BookingModule.selectedBooking);

      if (!bookingCopy1) {
        throw new Error(PSBErrors.NoBookingInModule);
      } // Before applying a new generic discount we remove any pending generic discount accounting that the user has previously created


      removeGenericDiscountAccountings(bookingCopy1); // TODO Hamza: If we have applied codes for this booking, then we remove their accountings
      //     - Remove pending payment code accountings of all applied payment codes

      removeAllPaymentCodePendingAccountings(bookingCopy1); //     - Remove pending discount code accountings of all applied discount codes

      removeAllDiscountCodePendingAccountings(bookingCopy1); // Now lets update the booking in the state before appyling the discount, and before applying any code

      BookingModule.updateBooking(bookingCopy1); // Lets make another copy of the booking from the state, because if we keep using the obj bookingCopy1 and then update it again in the state restToPay will not react and balance shown in UI will stay the bookingTotal

      var bookingCopy = cloneDeep(BookingModule.selectedBooking);

      if (!bookingCopy) {
        throw new Error(PSBErrors.NoBookingInModule);
      }

      var bookingPSS = bookingCopy.pssList;

      if (!bookingPSS || !bookingPSS.length) {
        return;
      }

      if (BookingModule.isEditOrderBooking) {
        // We're in EditOrder case, we don't apply discount on paid pss. Lets build an array of not completed pss
        bookingPSS = [];
        bookingCopy.pssList.forEach(function (pss) {
          if (!isPSSPaid(pss)) {
            bookingPSS.push(pss);
          }
        });
      }

      var discountPercentage = 0;
      /* BEGIN OF NEW LOGIC */
      // in the new logic:
      // 1- we know there is no specific tickets discount for fixed amount discount
      // 2- fixed amount discount is not going to be distributed on pss by generating a percentage, no, it is going to be distributed
      // on pss list pss by pss until the fixed discount amount is 0
      // We're doing this to avoid having decimals with cents in pss.pricevalue/pss._discountValue/accountingEntry.value

      var discountPrices = (_BookingModule$select12 = BookingModule.selectedBookingDiscountTrack) === null || _BookingModule$select12 === void 0 ? void 0 : _BookingModule$select12.pricesIds;
      var pssDiscounts = [];

      if (discountInfo.value.type === 1) {
        discountPercentage = discountInfo.value.value;
        var totalDiscountApplied = 0;
        var maxDiscountValueReached = false;
        var notCanceledPssList = bookingCopy.pssList.filter(function (pss) {
          return pss.bookingStatus !== BookingStatus.Canceled && pss.bookingStatus !== BookingStatus.Abandoned;
        });
        var sumOfNotCanceledPSSValues = sumArray(notCanceledPssList.map(function (pss) {
          return getPSSValue(pss);
        }));
        var amountPaid = BookingModule.amountPaid;

        var _iterator = _createForOfIteratorHelper(bookingPSS),
            _step;

        try {
          var _loop = function _loop() {
            var pss = _step.value;

            // If pss is already paid or canceled or abandoned then we don't apply discount on it
            if (isPSSPaid(pss) || pss.paymentStatus === PaymentStatus.Completed || pss.bookingStatus === BookingStatus.Canceled || pss.bookingStatus === BookingStatus.Abandoned) {
              return "continue";
            }

            if (!discountPrices) {
              // So current pss is not considered in the discount
              pss._discountValue = 0;
              return "continue";
            }

            if (discountPrices.findIndex(function (priceId) {
              return priceId === pss.priceId;
            }) > -1) {
              // So current pss is considered in this discount
              // we do not apply discounts to the excluded tax value of a pss
              var discountValue = Math.round((pssUnpaidValue(pss) - excludedTaxByPss.value(String(pss.uuid))) * discountPercentage / 100);
              totalDiscountApplied += discountValue;

              if (totalDiscountApplied >= sumOfNotCanceledPSSValues - amountPaid) {
                // we do not apply a discount value greater then the amount left to pay
                maxDiscountValueReached = true;
                discountValue = Math.min(sumOfNotCanceledPSSValues - amountPaid, discountValue);
              }

              pss._discountValue = discountValue;
              var applyTime = dayjs().toISOString();
              pssDiscounts.push({
                pssId: pss._id,
                pssUUID: pss.uuid,
                pssOriginalPriceValue: pssUnpaidValue(pss),
                pssNewPriceValue: pssUnpaidValue(pss) - pss._discountValue,
                priceId: pss.priceId,
                categoryId: pss.categoryId,
                applyTime: applyTime
              });

              if (maxDiscountValueReached) {
                return "break";
              }
            } else pss._discountValue = 0;
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ret = _loop();

            if (_ret === "continue") continue;
            if (_ret === "break") break;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (discountInfo.value.type === 2) {
        // now lets loop thru pss and make them fully discounted until we reach the discount amount decided by user
        var discountFixedAmount = discountInfo.value.value * 100;
        var remainingDiscountAmount = discountFixedAmount;
        var pssDiscountValueSum = 0;

        for (var i = 0; i < bookingPSS.length; i++) {
          var pss = bookingPSS[i]; // If pss is already paid or canceled or abandoned then we don't apply discount on it

          if (isPSSPaid(pss) || pss.paymentStatus === PaymentStatus.Completed || pss.bookingStatus === BookingStatus.Canceled || pss.bookingStatus === BookingStatus.Abandoned) {
            continue;
          }

          if (pssUnpaidValue(pss) <= remainingDiscountAmount) {
            // lets make this pss fully discounted
            pss._discountValue = pssUnpaidValue(pss); // decrease remainingDiscountAmount

            remainingDiscountAmount = remainingDiscountAmount - pssUnpaidValue(pss);
          } else {
            // so here (pss price value - pssPromocodeDiscount) is greater than what we still have as a discount amount to use
            // we will make a normal discount, not a full one
            pss._discountValue = remainingDiscountAmount;
            remainingDiscountAmount = 0;
          }

          pssDiscountValueSum += pss._discountValue;

          if (i === bookingPSS.length - 1 && currency.value === Currencies.CHF) {
            // Change the last pss discount value to a have a total sum of discounts be a multiple of 5 for CHF transactions
            // as CHF doesn't have coins below 5 cents
            // this is the sum of discounts we're looking for
            var roundedDiscountValueSum = roundToNearestMultipleOf5(pssDiscountValueSum); // calculate the difference between what we want and what we have

            var difference = roundedDiscountValueSum - pssDiscountValueSum; // add the difference to the last pss discount value

            pss._discountValue += difference;
          }

          var applyTime = dayjs().toISOString();
          pssDiscounts.push({
            pssId: pss._id,
            priceId: pss.priceId,
            pssUUID: pss.uuid,
            pssOriginalPriceValue: pssUnpaidValue(pss),
            pssNewPriceValue: pssUnpaidValue(pss) - pss._discountValue,
            categoryId: pss.categoryId,
            applyTime: applyTime
          });
        }
      }
      /* END OF NEW LOGIC */
      // Add tracking of this discount
      // Now update the discount as isApplied: true and add the pssDiscounts array


      BookingModule.applyDiscount({
        BookingUUID: BookingModule.selectedBookingUUID,
        pssDiscounts: pssDiscounts
      }); // Now we need to create genericDiscountAccountings
      // removeGenericDiscountAccountings(bookingCopy);

      createGenericDiscountAccountings(bookingCopy); // BookingModule.updateBooking(bookingCopy);
      // TODO Hamza: Recreate accountings for applied discount codes and then payment codes
      //     - Create discount code accountings of all applied discount codes
      // lets get all applied discount codes and sort them by applyDateTime

      var sortedAppliedDiscountCodes = BookingModule.appliedPromocodes.filter(function (p) {
        return p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_VOUCHER && p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_VOUCHER_SOLD && p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_GIFT_CARD && p.promocode.promoCodeType !== PromocodeCampaignType.TYPE_GIFT_CARD_SOLD;
      });
      /*.sort((p) => p.createdAt)*/

      for (var _i = 0; _i < sortedAppliedDiscountCodes.length; _i++) {
        createDiscountCodeAccounting(bookingCopy, sortedAppliedDiscountCodes[_i]);
      } // BookingModule.updateBooking(bookingCopy);
      //     - Create payment code accountings of all applied payment codes
      // lets get all applied payment codes and sort them by applyDateTime


      var sortedAppliedPaymentCodes = BookingModule.appliedPromocodes.filter(function (p) {
        return p.promocode.promoCodeType === PromocodeCampaignType.TYPE_VOUCHER || p.promocode.promoCodeType === PromocodeCampaignType.TYPE_VOUCHER_SOLD || p.promocode.promoCodeType === PromocodeCampaignType.TYPE_GIFT_CARD || p.promocode.promoCodeType === PromocodeCampaignType.TYPE_GIFT_CARD_SOLD;
      });
      /*.sort((p) => p.createdAt)*/

      for (var _i2 = 0; _i2 < sortedAppliedPaymentCodes.length; _i2++) {
        createPaymentCodeAccounting(bookingCopy, sortedAppliedPaymentCodes[_i2]);
      }

      BookingModule.updateBooking(bookingCopy); // Now lets update bookingCurrentAmount

      BookingModule.updateCurrentAmount({
        BookingUUID: BookingModule.selectedBookingUUID,
        amount: restToPay.value / 100
      });
      BookingModule.setSplitPaymentAmount({
        BookingUUID: BookingModule.selectedBookingUUID,
        splitAmount: restToPay.value / 100
      });

      if (restToPay.value > 0) {
        var bs = _defineProperty({}, String(BookingModule.selectedBookingUUID), BookingStep.Payment);

        BookingModule.setBookingStep(bs);
      }
    }

    var canceledOrAbandonedPssSum = computed(function () {
      var bookingCopy = cloneDeep(BookingModule.selectedBooking);
      var canceledPssList = (bookingCopy === null || bookingCopy === void 0 ? void 0 : bookingCopy.pssList.filter(function (pss) {
        return pss.bookingStatus === BookingStatus.Canceled || pss.bookingStatus === BookingStatus.Abandoned;
      }).map(function (pss) {
        return getPSSValue(pss);
      })) || [];
      return sumArray(canceledPssList);
    });
    var total = computed(function () {
      return !discountResult.value ? ((BookingModule.pssSum - canceledOrAbandonedPssSum.value) / 100).toFixed(2) : ((BookingModule.pssSum - canceledOrAbandonedPssSum.value - discountResult.value) / 100).toFixed(2);
    });
    return {
      calcIcon: calcIcon,
      calcAlt: calcAlt,
      calcIconStyle: calcIconStyle,
      predefinedDiscounts: predefinedDiscounts,
      discountInfo: discountInfo,
      DiscountTypes: DiscountTypes,
      discountResult: discountResult,
      // discountResult1,
      isDiscountApplied: isDiscountApplied,
      currency: currency,
      showCalculator: showCalculator,
      updateDiscountType: updateDiscountType,
      updateDiscountValue: updateDiscountValue,
      UpdateDiscountApplicationCoverage: UpdateDiscountApplicationCoverage,
      makeDiscountOnAllOrder: makeDiscountOnAllOrder,
      // applyDiscount,
      applyDiscount2: applyDiscount2,
      refreshDiscount: refreshDiscount,
      total: total
    };
  },
  created: function created() {
    // If the user refreses the page we will loose the discount he created, and the discount component will need a new one to show some options selected
    var d = BookingModule.selectedBookingDiscountTrack;

    if (d) {
      return;
    } // Since no discount or discount lost, lets create a new empty one


    initiateDiscount();
  }
});